import coverApi from '@/services/CoverApi'
import constants from '@/constants/index'
import dayjs from 'dayjs'

export default {
  namespaced: true,
  state: {
    covers: [],
    paginationData: {
      descending: true,
      page: 1,
      rowsPerPage: 5,
      sortBy: 'id',
      totalItems: 0,
      rowsPerPageItems: [5]
    },
    companyId: '',
    loading: true,
    nbRemainingDays: 3
  },
  getters: {
    covers: state => state.covers,
    nbRemainingDays: state => state.nbRemainingDays
  },
  mutations: {
    setPagination (state, paginationData) {
      state.paginationData = paginationData
    },
    setCoversQuotedTotalItems (state, totalItems) {
      state.paginationData.totalItems = totalItems
    },
    setCoversQuoted (state, covers) {
      state.covers = covers
    },
    changeLoadingState (state, loading) {
      state.loading = loading
    },
    setCoversCompanies (state, { companies }) {
      state.covers.forEach(function (cover) {
        cover.seller = companies.find(function (company) {
          return company.id === cover.sellerId
        })

        cover.buyer = companies.find(function (company) {
          return company.id === cover.buyerId
        })
      })
    },
    setCompanyId (state, companyId) {
      state.companyId = companyId
    }
  },
  actions: {
    async getCoversQuoted (context, payload) {
      let coverStatusLabels = payload.coverStatusLabels
      let companyId = payload.companyId
      let coverId = payload.coverId
      context.commit('changeLoadingState', true)
      let result = await coverApi.fetchCoversbyStatusPerPage(context.state.paginationData.page, context.state.paginationData.rowsPerPage, 'Quoted,Assessing', 'quotedAt', null, null, 'quotedAt', 'asc', companyId, coverId)
      if (result) {
        let emptyCompany = {
          id: '',
          name: '',
          identifierType: '',
          identifierValue: ''
        }
        let covers = result.items.map((item) => {
          return {
            id: item.id,
            sellerId: item.sellerId,
            buyerId: item.buyerId,
            issuedAt: item.invoice.issuedAt,
            dueAt: item.invoice.dueAt,
            amount: item.invoice.amount + ' ' + item.invoice.currency.toUpperCase(),
            currency: item.invoice.currency.toUpperCase(),
            status: coverStatusLabels.findIndex(x => x.name === item.status) >= 0 ? coverStatusLabels.find(x => x.name === item.status).label : item.status,
            isRemaining: item.status.toLowerCase() === constants.CoverStatus.QUOTED.toLowerCase() && dayjs(item.coverage.validUntil).add(1, 'days').diff(dayjs(), 'days') <= context.state.nbRemainingDays,
            daysRemaining: dayjs(item.coverage.validUntil).startOf('day').add(1, 'days').diff(dayjs().startOf('day'), 'days'),
            statusCode: item.status,
            seller: emptyCompany,
            buyer: emptyCompany
          }
        })
        let totalItems = result.totalCount
        context.commit('setCoversQuoted', covers)
        context.commit('setCoversQuotedTotalItems', totalItems)
        if (totalItems > 0) {
          let sellerIds = covers.map((item) => { return item.sellerId })
          let buyerIds = covers.map((item) => { return item.buyerId })
          let companyIds = [...new Set(sellerIds.concat(buyerIds))]
          context.dispatch('setCoversCompanies', await coverApi.fetchMappedCompaniesFromId(companyIds))
        }
      }
      context.commit('changeLoadingState', false)
    },
    setPagination (context, paginationData) {
      context.commit('setPagination', paginationData)
    },
    setCoversCompanies (context, companies) {
      context.commit('setCoversCompanies', { companies })
    },
    startLoadCovers (context) {
      context.commit('changeLoadingState', true)
    },
    setCompanyId (context, companyId) {
      context.commit('setCompanyId', companyId)
    },
    getEmptyCovers (context) {
      context.commit('setCoversQuoted', [])
      context.commit('setCoversQuotedTotalItems', 0)
      context.commit('changeLoadingState', false)
    }
  }
}
